import useSWR from 'swr';
import axios from 'axios';
import { useToken } from '../auth/token';

let swrData: any = [];
let swrData2: any = [];
let mutateList: any = [];

export function useTradeList(ep_id: number) {
  let KEY = ep_id ? `/trade/tradelist?ep_id=${ep_id}` : null;

  const { data: token } = useToken();
  const { data, mutate } = useSWR<any>(
    KEY ? `${import.meta.env.VITE_APP_API_URL}${KEY}` : null,
    async (url) => {
      if (swrData[ep_id] != undefined) return swrData[ep_id] || [];

      const result = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      swrData[ep_id] = result.data.result || [];
      return swrData[ep_id];
    }
  );

  swrData2[ep_id] = data;
  if (mutateList[ep_id] == null) mutateList[ep_id] = mutate;

  return {
    data,
    getData: (epid?: any) => {
      if (swrData2[epid ? epid : ep_id]) return swrData2[epid ? epid : ep_id];
      else return null;
    },
    mutate: (value?: any, epid?: any) => {
      if (value !== undefined) swrData[epid ? epid : ep_id] = value;
      if (mutateList[epid ? epid : ep_id] == null) {
        return mutate();
      } else {
        return mutateList[epid ? epid : ep_id]();
      }
    },
    pushmutate: (value?: any, epid?: any) => {
      try {
        if (!value || !Array.isArray(value)) {
          console.warn('pushmutate: invalid value provided');
          return Promise.resolve([]);
        }

        const targetEpId = epid ?? ep_id;
        const currentData = Array.isArray(swrData[targetEpId])
          ? swrData[targetEpId]
          : [];

        // 새로운 배열 생성
        const temp = [...value, ...currentData].slice(0, 50);
        swrData[targetEpId] = temp;

        // mutate 함수 안전하게 호출
        if (mutateList[targetEpId]) {
          return mutateList[targetEpId]();
        } else if (mutate) {
          return mutate();
        } else {
          return Promise.resolve(temp);
        }
      } catch (e) {
        console.error('pushmutate error:', e);
        return Promise.resolve([]);
      }
    },
  };
}
